import type { Maybe, Undef } from 'types/UtilityTypes';
import { QuotingPortals } from 'types/enums/Integrations';
import {
  type SuggestedQuoteChange,
  SuggestionSourceCategories,
} from 'types/suggestions/QuoteSuggestions';

type PortalLoadIdSuggestionFields = Pick<
  SuggestedQuoteChange,
  'source' | 'sourceCategory' | 'sourceExternalID'
>;

function isQuotingPortalSource(source: string): boolean {
  return Object.values(QuotingPortals).includes(source as QuotingPortals);
}

/**
 * Portal-originated suggestions carry a portal shipment/load id in
 * {@link SuggestedQuoteChange.sourceExternalID}. A portal email keeps the `email` category for
 * provenance, so the source value distinguishes it from an ordinary email suggestion.
 */
export function portalLoadIdCandidateFromQuotingPortalSuggestion(
  suggestion:
    Maybe<PortalLoadIdSuggestionFields> | Undef<PortalLoadIdSuggestionFields>
): string {
  if (!suggestion) {
    return '';
  }

  const isPortalSuggestion =
    suggestion.sourceCategory === SuggestionSourceCategories.QuotingPortal ||
    (suggestion.sourceCategory === SuggestionSourceCategories.Email &&
      isQuotingPortalSource(suggestion.source));

  if (!isPortalSuggestion) {
    return '';
  }

  return suggestion.sourceExternalID?.trim() ?? '';
}
